import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { uploadToS3, listFiles } from 'actions/s3Manager'
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  withStyles,
  withMobileDialog,
  Menu,
  MenuItem,
  // ListItemIcon,
  // ListItemText,
} from '@material-ui/core'
import { Upload } from 'mdi-material-ui'
import { AttachFile, Public } from '@material-ui/icons'
import S3Manager from 'components/S3Manager'
import Button from 'components/theme/Button'

const S3ManagerMenu = ({
  classes,
  fullScreen,
  clickFile,
  listFiles,
  // fileList,
  // baseUrl,
  uploadToS3,
  style,
}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(false)
  const fileInputRef = useRef()

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const handleChange = e => {
    const file = e?.target?.files?.[0]
    console.log(file)

    listFiles().then(payload => {
      const string =
        payload?.baseUrl +
        payload?.data?.Prefix +
        encodeURIComponent(file?.name)

      console.log('string: ', string)

      uploadToS3(file?.name, file).then(() => {
        clickFile(string)
      })
    })
    // console.log(e?.target?.files?.[0]?.name)
    // console.log(e?.target?.files?.[0])
  }

  return (
    <>
      <IconButton
        // buttonRef={(node) => {
        // 	this.anchorEl = node
        // }}
        onMouseDown={e => e.preventDefault()}
        onPointerDown={e => e.preventDefault()}
        classes={style ? {} : { root: classes.root }}
        style={style || {}}
        // style={{ position: 'absolute', left: 30, marginTop: 8 }}
        variant="outlined"
        size="small"
        aria-owns={open ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        // disabled={disabled || (!conversationSelected && !contactSelected)}
      >
        <AttachFile />
      </IconButton>
      <input
        onChange={handleChange}
        multiple={false}
        ref={fileInputRef}
        type="file"
        hidden
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose()
            setOpen(true)
          }}
        >
          <Public style={{ marginRight: 5 }} />
          Public files
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose()
            return fileInputRef?.current?.click?.()
          }}
        >
          <Upload style={{ marginRight: 5 }} />
          Upload from your device
        </MenuItem>
      </Menu>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        // style={{ borderRadius: 22 }}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xl"
        PaperProps={{ classes: { rounded: classes.rounded } }}
        // classes={{ paperFullWidth: classes.paperFullWidth }}
      >
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
          <S3Manager
            clickFile={url => {
              clickFile(url)
              setOpen(false)
            }}
          />
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogActionsRoot }}>
          <Button
            onClick={() => {
              setOpen(false)
            }}
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const styles = theme => ({
  rounded: {
    borderRadius: 28,
    // overflowY: 'hidden',
    // height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      // overflowY: 'auto',
    },
  },
  dialogContentRoot: {
    padding: 0,
    '&:first-child': { paddingTop: 0 },
  },
  dialogActionsRoot: {
    margin: 0,
    padding: '8px 4px',
    borderTop: '1px solid #808080',
  },
  root: {
    padding: 3,
    position: 'absolute',
    left: 30,
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      left: 4,
    },
  },
})

export default connect(
  /* (state) => ({
		fileList: state.s3Manager?.fileList,
		baseUrl: state.s3Manager?.baseUrl || '',
	}) */ null,
  dispatch => bindActionCreators({ uploadToS3, listFiles }, dispatch),
)(withStyles(styles)(withMobileDialog()(S3ManagerMenu)))
